var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1929 0 0 11.2055 0 25.0283C0 31.8496 2.7258 38.0336 7.14642 42.548C11.7857 47.1961 11.7956 48.7017 12.8571 52.9169H25V0Z",
    fill: "#E6D262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25.0283C50 11.2055 38.8071 0 25 0V52.9169H37.1429C38.2044 48.7017 38.2143 47.1961 42.8536 42.548C47.2742 38.0336 50 31.8496 50 25.0283Z",
    fill: "#DCB902"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 52.9169C9.28571 52.9169 9.28571 57.9225 12.8571 57.9225H37.1429C40.7143 57.9225 40.7143 52.9169 37.1429 52.9169H25H12.8571Z",
    fill: "#987C39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 57.9225C9.28571 57.9225 9.28571 62.9282 12.8571 62.9282H37.1429C40.7143 62.9282 40.7143 57.9225 37.1429 57.9225H12.8571Z",
    fill: "#141414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 62.9282C9.28571 62.9282 9.28571 67.9338 12.8571 67.9338H37.1429C40.7143 67.9338 40.7143 62.9282 37.1429 62.9282H12.8571Z",
    fill: "#987C39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8571 67.9338C9.28571 67.9338 9.28571 72.9395 12.8571 72.9395H15.7143H34.2857H37.1429C40.7143 72.9395 40.7143 67.9338 37.1429 67.9338H12.8571Z",
    fill: "#141414"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 72.9395L21.4286 78.6602C22.2966 79.5292 23.249 79.9758 24.2857 80H25.7143C26.7511 79.9758 27.7034 79.5292 28.5714 78.6602L34.2857 72.9395H15.7143Z",
    fill: "#987C39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon1);
export default __webpack_public_path__ + "static/media/service-icon-1.792cbaeec2adc36bfdd2f17b30a37bc5.svg";
export { ForwardRef as ReactComponent };